import calculateHeadToHead from "./calculateHeadToHead";

const sortGroups = (groups, schedule, matches, teamStats, headToHead) => {
  const sortedGroups = {};

  for (const [groupId, teamIds] of Object.entries(groups)) {
    const sortedTeamIds = [...teamIds].sort((teamAId, teamBId) => {
      const teamAStats = teamStats[teamAId];
      const teamBStats = teamStats[teamBId];

      return (
        teamBStats.points - teamAStats.points ||
        teamBStats.wins - teamAStats.wins ||
        teamBStats.draws - teamAStats.draws ||
        teamAStats.losses - teamBStats.losses ||
        (headToHead
          ? calculateHeadToHead(
              teamAId,
              teamBId,
              teamIds,
              schedule,
              matches,
              teamStats
            )
          : 0) ||
        teamBStats.goalDifference - teamAStats.goalDifference ||
        teamBStats.goalsFor - teamAStats.goalsFor ||
        teamBStats.goalsAgainst - teamAStats.goalsAgainst ||
        0
      );
    });

    sortedGroups[groupId] = sortedTeamIds;
  }

  return sortedGroups;
};

export default sortGroups;
